export default __webpack_public_path__ + "static/media/JS.75160295.png";